import React, { FunctionComponent } from "react"
import HRRService from "src/pages/hr_reports/utils/HRRService"

const HRRViewReportTableBody: FunctionComponent<{}> = () => {

    const { state } = HRRService
    const { employeeReport, selectedReport } = state

    return (
        <tbody>
            {employeeReport.map((employee, i) =>
                <tr key={i}>
                    {/*@ts-ignore*/}
                    {selectedReport.properties.items.map((item, j) =>
                        <td key={j}>
                            {employee[item.key]}
                        </td>
                    )}
                </tr>
            )}
        </tbody>
    )
}

export default HRRViewReportTableBody